<template>
    <div v-loading="loading">
        <template v-if="form">
            <has-error :form="form" field="password" class="text-danger d-block small" />
            <div class="form-group mb-1">
                <div class="custom-control custom-switch">
                    <input type="checkbox" :id="'is_active' + _uid" class="custom-control-input" v-model="is_active">
                    <label :for="'is_active' + _uid" class="custom-control-label">Активен</label>
                </div>
                <has-error :form="form" field="is_active" class="text-danger d-block small" />
            </div>
            <div class="form-row">
                <div class="col-6">
                    <div class="form-group mb-1">
                        <label for="user_form_name" class="form-label mb-1">Имя</label>
                        <input id="user_form_name" type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" v-model="name" @change="onEdit">
                        <has-error :form="form" field="name"/>
                    </div>
                    <div class="form-group mb-1">
                        <label for="user_form_login" class="form-label mb-1">Логин</label>
                        <input id="user_form_login" type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('login') }" v-model="login" @change="onEdit">
                        <has-error :form="form" field="login"/>
                    </div>
                    <div class="form-group mb-1">
                        <label for="user_form_roles" class="form-label mb-1">Роль</label>
                        <multiselect :disabled="!$hasRole('admin')" id="user_form_roles" @input="onEdit" @remove="onEdit" v-model="roles_temp" :options="roles_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''"></multiselect>
                        <has-error :form="form" field="roles" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1">
                        <label for="user_form_permissions" class="form-label mb-1">Дополнительные права</label>
                        <multiselect id="user_form_permissions" @input="onEdit" @remove="onEdit" v-model="permissions_temp" :options="permissions_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''"></multiselect>
                        <has-error :form="form" field="permissions" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="usePlatforms">
                        <label for="user_form_platforms" class="form-label mb-1">Площадка</label>
                        <multiselect :disabled="!$hasRole('admin')" id="user_form_platforms" @input="onEdit" @remove="onEdit" v-model="platforms_temp" :options="platforms_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''"></multiselect>
                        <has-error :form="form" field="platforms" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useCallCenters">
                        <label for="user_form_call_centers" class="form-label mb-1">Колл-центр</label>
                        <multiselect :disabled="!$hasRole('admin')" id="user_form_call_centers" @input="onEdit" @remove="onEdit" v-model="call_centers_temp" :options="call_centers_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''"></multiselect>
                        <has-error :form="form" field="call_centers" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useSources">
                        <label for="user_form_sources" class="form-label mb-1">Источники (<a @click="sourcesSelectAll" class="small">выбрать всё</a>, <a @click="sourcesClear" class="small">очистить</a>)</label>
                        <multiselect :disabled="!$hasRole('admin')" id="user_form_sources" @input="onEdit" @remove="onEdit" v-model="sources_temp" :options="sources_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''">
                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length && !isOpen">Выбрано {{ values.length }}</span>
                            </template>
                        </multiselect>
                        <has-error :form="form" field="sources" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useCarWarehouse">
                        <label for="user_form_warehouses" class="form-label mb-1">Склад</label>
                        <multiselect :disabled="!$hasRole('admin')" id="user_form_warehouses" @input="onEdit" @remove="onEdit" v-model="warehouses_temp" :options="platforms_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''"></multiselect>
                        <has-error :form="form" field="warehouses" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useDistributionRequests">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" :id="'distribution_requests' + _uid" class="custom-control-input" v-model="distribution_requests">
                            <label :for="'distribution_requests' + _uid" class="custom-control-label">Участвует в распределении лидов</label>
                        </div>
                        <has-error :form="form" field="distribution_requests" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useCallQuality">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" :id="'call_quality_enabled' + _uid" class="custom-control-input" v-model="call_quality_enabled">
                            <label :for="'call_quality_enabled' + _uid" class="custom-control-label">Контроль качества звонков</label>
                        </div>
                        <has-error :form="form" field="call_quality_enabled" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useSip">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" :id="'sip_use' + _uid" class="custom-control-input" v-model="sip_use">
                            <label :for="'sip_use' + _uid" class="custom-control-label">Телефония</label>
                        </div>
                        <has-error :form="form" field="sip_use" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1" v-if="useSip">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" :id="'dialer_enabled' + _uid" class="custom-control-input" v-model="dialer_enabled">
                            <label :for="'dialer_enabled' + _uid" class="custom-control-label">Дайлер</label>
                        </div>
                        <has-error :form="form" field="dialer_enabled" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" :id="'google2fa_use' + _uid" class="custom-control-input" v-model="google2fa_use">
                            <label :for="'google2fa_use' + _uid" class="custom-control-label">Двухфакторная аутентификация (2FA)</label>
                        </div>
                        <has-error :form="form" field="distribution_requests" class="text-danger d-block small" />
                    </div>
                    <div class="form-group mb-1">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" :id="'logout_when_offline' + _uid" class="custom-control-input" v-model="logout_when_offline">
                            <label :for="'logout_when_offline' + _uid" class="custom-control-label">Выбрасывать из логина при оффлайне</label>
                        </div>
                        <has-error :form="form" field="logout_when_offline" class="text-danger d-block small" />
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group mb-1">
                        <label :for="'position_id' + _uid" class="form-label mb-1">Должность</label>
                        <PositionSelect :platform_ids="platform_ids" v-model="position_id" />
                        <has-error :form="form" field="position_id"/>
                    </div>
                    <div class="form-row">
                        <div class="form-group mb-1 col-12">
                            <label for="user_form_basis_name" class="form-label mb-1">Действующий на основании (устава, доверенности)</label>
                            <input id="user_form_basis_name" type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('basis_name') }" v-model="basis_name" @change="onEdit">
                            <has-error :form="form" field="basis_name"/>
                        </div>
                        <div class="form-group mb-1 col-6">
                            <label for="user_form_basis_number" class="form-label mb-1">Номер</label>
                            <input id="user_form_basis_number" type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('basis_number') }" v-model="basis_number" @change="onEdit">
                            <has-error :form="form" field="basis_number"/>
                        </div>
                        <div class="form-group mb-1 col-6">
                            <label for="user_form_basis_from" class="form-label mb-1">Действует от</label>
                            <input id="user_form_basis_from" type="date" class="form-control" :class="{ 'is-invalid': form.errors.has('basis_from') }" v-model="basis_from" @change="onEdit">
                            <has-error :form="form" field="basis_from"/>
                        </div>
                    </div>
                    <div class="form-row" v-if="role_ids.includes('operator') && platform_ids.length">
                        <div class="form-group mb-1 col-12">
                            <label :for="'user_group_id' + _uid" class="form-label mb-1">Группа пользователей</label>
                            <UserGroupSelect v-model="user_group_id" :id="'user_group_id' + _uid" :filter_platforms="platform_ids" @change="onEdit" />
                            <has-error :form="form" field="user_group_id"/>
                        </div>
                    </div>
                    <div class="small text-muted pt-4" v-if="user">
                        <div class="row">
                            <div class="col-6">Браузер</div>
                            <div class="col-6">{{user.browser}}</div>
                        </div>
                        <div class="row">
                            <div class="col-6">Ось</div>
                            <div class="col-6">{{user.os}}</div>
                        </div>
                        <div class="row">
                            <div class="col-6">Последний логин</div>
                            <div class="col-6">{{user.last_login}}</div>
                        </div>
                        <div class="row">
                            <div class="col-6">Последний релод стр</div>
                            <div class="col-6">{{user.last_reload}}</div>
                        </div>
                        <div class="row">
                            <div class="col-6">Был онлайн последний раз</div>
                            <div class="col-6">{{user.last_activity_at}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group mb-1 mt-3">
                <button v-if="mode === 'edit'" class="btn btn-primary" @click="update">Сохранить</button>
                <button v-if="mode === 'create'" class="btn btn-primary" @click="create">Создать</button>
            </div>
        </template>
    </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import RoleData from "../../plugins/role_data";
import Form from "vform";
import toastr from "toastr";
import PositionSelect from "../positions/PositionSelect";
import UserGroupSelect from "../user_groups/UserGroupSelect.vue";

export default {
    name: "UserForm",
    components: {UserGroupSelect, PositionSelect, Multiselect},
    props: {
        mode: {
            type: String,
            require: true,
        },
        user: {
            type: Object,
        },
    },
    data: () => ({
        form: new Form(),

        is_active: null,
        name: null,
        attorney: null,
        basis_name: null,
        basis_number: null,
        basis_from: null,
        position_id: null,
        user_group_id: null,
        // email: null,
        // email_login: null,
        // email_hostname: window.location.hostname,
        login: null,
        roles_temp: [],
        permissions_temp: [],
        platforms_temp: [],
        warehouses_temp: [],
        call_centers_temp: [],
        sources_temp: [],
        distribution_requests: null,
        call_quality_enabled: null,
        dialer_enabled: null,
        sip_use: null,
        google2fa_use: null,
        logout_when_offline: null,

        // email_login_regex: "^[0-9a-z][0-9a-z-_.]{2,50}$",
        loading: false,
    }),
    mounted() {
        let self = this;

        let form_fields = {
            name: null,
            roles: [],
        };
        if (this.user) {
            form_fields.name = this.user.name;
            form_fields.attorney = this.user.attorney;
            form_fields.basis_name = this.user.basis_name;
            form_fields.basis_number = this.user.basis_number;
            form_fields.basis_from = this.user.basis_from;
            form_fields.position_id = this.user.position_id;
            form_fields.user_group_id = this.user.user_group_id;
            // form_fields.email = this.user.email;
            form_fields.login = this.user.login;
            form_fields.roles = _.map(this.user.roles, (i) => {return i.name});
            form_fields.platforms = _.map(this.user.allowed_platforms, (i) => {return i.id});
            form_fields.call_centers = _.map(this.user.call_centers, (i) => {return i.id});

            this.name = this.user.name;
            this.attorney = this.user.attorney;
            this.basis_name = this.user.basis_name;
            this.basis_number = this.user.basis_number;
            this.basis_from = this.user.basis_from;
            this.position_id = this.user.position_id;
            this.user_group_id = this.user.user_group_id;
            // this.email = this.user.email;
            // let email_parts = this.user.email.split("@");
            // this.email_login = email_parts[0];
            // this.email_hostname = email_parts[1];
            this.login = this.user.login;
            this.user.roles.forEach(function (role) {
                let item = RoleData.getBySlug(role.name);
                if (item) self.roles_temp.push({id: item.slug, text: item.label});
            });
            this.user.permissions.forEach(function (p) {
                let item = _.find(self.permissions_select, {id: p.name});
                if (item) self.permissions_temp.push({id: item.id, text: item.text});
            });
            this.user.allowed_platforms.forEach(function (pl) {
                self.platforms_temp.push({id: pl.id, text: pl.name});
            });
            this.user.allowed_warehouses.forEach(function (pl) {
                self.warehouses_temp.push({id: pl.id, text: pl.name});
            });
            this.user.call_centers.forEach(function (cc) {
                self.call_centers_temp.push({id: cc.id, text: cc.name});
            });
            this.user.allowed_sources.forEach(function (s) {
                self.sources_temp.push({id: s.id, text: s.name});
            });
            this.distribution_requests = this.user.distribution_requests;
            this.call_quality_enabled = this.user.call_quality_enabled !== undefined ? this.user.call_quality_enabled : false;
            this.is_active = this.user.is_active;
            this.sip_use = this.user.sip_use;
            this.dialer_enabled = !!this.user.dialer_enabled;
            this.google2fa_use = this.user.google2fa_use;
            this.logout_when_offline = this.user.logout_when_offline;
        } else {
            this.is_active = true;
            this.distribution_requests = true;
            this.call_quality_enabled = false;
            this.dialer_enabled = false;
            this.google2fa_use = true;
            this.logout_when_offline = false;
        }
        this.form = new Form(form_fields);
    },
    watch: {
        // roles_temp(val) {
        //     this.onEdit();
        // },
    },
    computed: {
        roles_select() {
            return RoleData.forSelect();
        },
        permissions_select() {
            return [
                {id: 'affiliate_sales.lock', text: 'Продажи доп продуктов: блокировка'},
                {id: 'operations.cash.update_old', text: 'Операции по кассе: обновление старых'},
                {id: 'operations.cash.delete_old', text: 'Операции по кассе: удаление старых'},
                {id: 'cars.update_pts_vin', text: 'Машины: изменение VIN'},
                {id: 'operations.cars.increase', text: 'Наценка на авто'},
                {id: 'request.phone.show_full', text: 'Заявки: показывать номер телефона после 2FA'},
                {id: 'request.phone.show_full.without_challenge', text: 'Заявки: не скрывать номер телефона'},
                {id: 'reports.motivation.rop', text: 'Мотивация: просмотр РОПа'},
                {id: 'dialer.show', text: 'Дайлер: просмотр'},
                {id: 'dialer.manage', text: 'Дайлер: управление'},
            ];
        },
        platforms_select() {
            let select = [];
            this.$store.getters['platforms/all'].forEach(function (item) {select.push({id: item.id, text: item.name,})});
            select = _.sortBy(select, ['text']);
            return select;
        },
        platform_ids() {
            return _.map(this.platforms_temp, (i) => {return i.id});
        },
        role_ids() {
            return _.map(this.roles_temp, (i) => {return i.id})
        },
        call_centers_select() {
            let centers = [];
            let user = this.$store.getters['auth/user'];
            if(user && user.call_centers && user.call_centers.length) {
                user.call_centers.forEach(function (item) {centers.push({id: item.id, text: item.name,})});
            }
            return centers;
        },
        sources_select() {
            let select = [];
            this.$store.getters['sources/all'].forEach(function (item) {select.push({id: item.id, text: item.name,})});
            select = _.sortBy(select, ['text']);
            return select;
        },


        usePlatforms() {
            return true;
        },
        useCallCenters() {
            if (
                _.find(this.roles_temp, {id: "admin"})
                || _.find(this.roles_temp, {id: "operator"})
                || _.find(this.roles_temp, {id: "head_of_call_center"})
            ) {
                return true;
            }
            return false;
        },
        useSources() {
            if (_.find(this.roles_temp, {id: "ad_agency"})) {
                return true;
            }
            return false;
        },
        useCarWarehouse() {
            if (
                _.find(this.roles_temp, {id: "admin"})
                || _.find(this.roles_temp, {id: "investor"})
                || _.find(this.roles_temp, {id: "head_of_call_center"})
                || _.find(this.roles_temp, {id: "operator"})
                || _.find(this.roles_temp, {id: "head_of_sales_department"})
                || _.find(this.roles_temp, {id: "sales_manager"})
                || _.find(this.roles_temp, {id: "head_of_credit_department"})
                || _.find(this.roles_temp, {id: "credit_manager"})
                || _.find(this.roles_temp, {id: "cashier"})
                || _.find(this.roles_temp, {id: "ad_agency"})
            ) {
                return true;
            }
            return false;
        },
        useDistributionRequests() {
            return !!_.find(this.roles_temp, {id: "operator"});
        },
        useSip() {
            return !!_.find(this.roles_temp, {id: "operator"});
        },
        useCallQuality() {
            return !!_.find(this.roles_temp, {id: "operator"});
        }
    },
    methods: {
        // validateEmailLogin(val) {
        //     return (new RegExp(this.email_login_regex, 'g')).test(val);
        // },
        validate() {
            this.form = new Form();
            if (!this.name || !this.name.length) this.form.errors.set('name', ['Имя не может быть пустым']);
            if (!this.platforms_temp.length) this.form.errors.set('platforms', ['Выбрерите хотябы одну площадку']);

            return !this.form.errors.any();
        },
        generateForm() {
            let data = {};
            data.name = this.name;
            data.attorney = this.attorney;
            data.basis_name = this.basis_name;
            data.basis_number = this.basis_number;
            data.basis_from = this.basis_from;
            data.position_id = this.position_id;
            data.user_group_id = this.user_group_id;
            data.email = this.email_login + "@" + this.email_hostname;
            data.login = this.login;
            data.roles = _.map(this.roles_temp, (i) => {return i.id});
            data.permissions = _.map(this.permissions_temp, (i) => {return i.id});
            data.platforms = this.usePlatforms ? _.map(this.platforms_temp, (i) => {return i.id}) : [];
            data.warehouses = this.useCarWarehouse ? _.map(this.warehouses_temp, (i) => {return i.id}) : [];
            data.call_centers = this.useCallCenters ? _.map(this.call_centers_temp, (i) => {return i.id}) : [];
            data.sources = this.useSources ? _.map(this.sources_temp, (i) => {return i.id}) : [];
            if (this.mode === "create") data.password = Math.random().toString(36).slice(-8);
            data.distribution_requests = this.useDistributionRequests ? this.distribution_requests : null;
            data.call_quality_enabled = this.useCallQuality ? this.call_quality_enabled : null;
            data.is_active = this.is_active;
            data.sip_use = this.useSip ? this.sip_use : null;
            data.dialer_enabled = this.useSip ? this.dialer_enabled : null;
            data.google2fa_use = this.google2fa_use;
            data.logout_when_offline = this.logout_when_offline;

            return new Form(data);
        },
        onEdit() {
            if (this.validate()) {
                let new_form = this.generateForm();
            }
        },

        update() {
            let self = this;
            this.loading = true;
            if (this.validate()) {
                let form = this.generateForm();
                form.put('/api/users/' + this.user.id)
                    .then(function (res) {
                        self.loading = false
                        self.$emit('updated', res.data);
                        self.$emit('close', form);
                    })
                    .catch(function (e) {
                        self.loading = false
                        self.form = form;
                    });
            } else {
                this.loading = false;
            }
        },
        create() {
            let self = this;
            this.loading = true;
            if (this.validate()) {
                let form = this.generateForm();
                form.post('/api/users')
                    .then(function (a) {
                        self.loading = false
                        self.$bus.$emit('user:created');
                        self.$emit('created', form);
                        self.$emit('close', form);
                    })
                    .catch(function (e) {
                        self.loading = false
                        self.form = form;
                    });
            } else {
                this.loading = false;
            }
        },
        sourcesSelectAll() {
            this.sources_temp = this.sources_select;
        },
        sourcesClear() {
            this.sources_temp = [];
        },

    },
}
</script>

<style scoped>

</style>
